import React, { useState } from 'react'
import { Form, Card, Button, Row, Col, Table } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import Colors from '../../constants/Colors'
import callApi from '../../helpers/callapi'

const MoveLottery = () => {
  const [receiverId, setReceiverId] = useState('')
  const [orderId, setOrderId] = useState('')
  const [order, setOrder] = useState({})
  const [receiver, setReceiver] = useState({})
  const dispatch = useDispatch()

  const searchOrder = async () => {
    try {
      const response = await callApi({
        url: `/orders?limit=50&q=${orderId}`,
      })

      setOrder(response.results[0])
    } catch (error) {
      console.log('err', error)

      Swal.fire({
        icon: 'error',
        title: 'ไม่พบรายการที่ค้นหา',
        showCloseButton: true,
      })
    }
  }

  const searchReceiver = async () => {
    try {
      const response = await callApi({
        url: '/users/queryLineName',
        method: 'post',
        body: { userId: receiverId.toLocaleUpperCase() },
      })
      if (response.status === 'error') {
        Swal.fire({
          icon: 'error',
          title: 'ไม่พบผู้ใช้',
          showCloseButton: true,
        })

        return false
      }
      setReceiver(response)
    } catch (error) {
      alert('ไม่พบรหัสผู้ใช้')
    }
  }

  const sendLotteryOrder = async () => {
    Swal.fire({
      title: `กรุณายืนยันการย้ายลอตเตอรี่`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: `${Colors.SOFT_BLUE}`,
      cancelButtonColor: `${Colors.LIGHT_RED}`,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch({ type: 'loading_show' })
        const lottery = await callApi({
          url: '/orders/sendGift',
          method: 'post',
          body: { orderId: order.id, receiver: receiver.id },
        })

        if (lottery.status === 'success') {
          Swal.fire({
            icon: 'success',
            title: 'ย้ายลอตเตอรี่สำเร็จ',
            showConfirmButton: false,
            timer: 3000,
          })
          dispatch({ type: 'loading_hide' })
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'พบข้อผิดพลาด ไม่สามารถย้ายลอตเตอรี่ได้',
          })
          dispatch({ type: 'loading_hide' })
        }
      }
    })
  }

  const displayTableOrder = () => {
    return (
      <>
        <Card.Title className="my-4">ผลการค้นหารายการ</Card.Title>
        <Table responsive striped bordered className="verticle-middle mb-5">
          <thead>
            <tr>
              <th>รหัสสมาชิก</th>
              <th>Order Owner</th>
              <th>สถานะการซื้อ</th>
              <th>OrderID</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{order?.user?.userId}</td>
              <td>{order?.user?.name}</td>
              <td>{order?.status}</td>
              <td>{order?.refNo}</td>
            </tr>
          </tbody>
        </Table>
      </>
    )
  }

  const displayTableUser = () => {
    return (
      <>
        <Card.Title className="my-4">ผลการค้นหารหัสสมาชิก</Card.Title>
        <Table responsive striped bordered className="verticle-middle">
          <thead>
            <tr>
              <th>รหัสสมาชิก</th>
              <th>ชื่อลูกค้า</th>
              <th>สถานะ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{receiver?.userId}</td>
              <td>{receiver?.lineName}</td>
              <td>{receiver?.status}</td>
            </tr>
          </tbody>
        </Table>
      </>
    )
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title>ย้ายลอตเตอรี่</Card.Title>
      </Card.Header>
      <Card.Body>
        <Form.Group className="pb-5">
          <Row>
            <Col sm={12} md={6} lg={4}>
              <input
                className="form-control my-2"
                style={{ color: Colors.DARK_GREY }}
                type="text"
                placeholder="เลขที่คำสั่งซื้อ"
                defaultValue={orderId}
                onChange={(e) => setOrderId(e.target.value)}
              />
            </Col>
            <Col sm={12} md={12} lg={4}>
              <Button variant="primary light" className="w-50 my-2" onClick={searchOrder}>
                ค้นหา
              </Button>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={6} lg={4}>
              <input
                className="form-control my-2"
                style={{ color: Colors.DARK_GREY, textTransform: 'uppercase' }}
                type="text"
                placeholder="รหัสสมาชิกของผู้รับ"
                onChange={(e) => setReceiverId(e.target.value)}
              />
            </Col>
            <Col sm={12} md={12} lg={4}>
              <Button variant="primary light" className="w-50 my-2" onClick={searchReceiver}>
                ค้นหา
              </Button>
            </Col>
          </Row>
        </Form.Group>

        {Object.keys(order).length > 0 && displayTableOrder()}

        {Object.keys(receiver).length > 0 && displayTableUser()}

        {Object.keys(order).length > 0 && Object.keys(receiver).length > 0 && (
          <div className="text-center">
            <Button variant="primary light" className="w-50 my-2 " onClick={sendLotteryOrder}>
              ย้ายลอตเตอรี่
            </Button>
          </div>
        )}
      </Card.Body>
    </Card>
  )
}
export default MoveLottery
